import type { Comic } from '@panels/shared';
import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { ComicActions } from '../components/ComicActions.js';
import { ComicStrip } from '../components/ComicStrip.js';
import { ErrorNote, Screen, Spinner } from '../components/ui.js';
import { ApiError, getSharedComic } from '../lib/api.js';

/** Public, unlisted comic page. No identity, no join, no login (§9). */
export function SharedComic() {
  const { shareToken } = useParams<{ shareToken: string }>();
  const [comic, setComic] = useState<Comic | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!shareToken) return;
    getSharedComic(shareToken)
      .then(setComic)
      .catch((err) => setError(err instanceof ApiError ? err.message : 'That link is no longer available'));
  }, [shareToken]);

  if (error) {
    return (
      <Screen title="Panels">
        <ErrorNote>{error}</ErrorNote>
        <Link className="button" to="/">
          Go to Panels
        </Link>
      </Screen>
    );
  }
  if (!comic) return <Spinner label="Loading comic…" />;

  return (
    <Screen wide>
      <div className="share-head">
        <span className="home-title small">PANELS</span>
        <h2>{comic.title ?? `${comic.starter.displayName}'s comic`}</h2>
      </div>
      <ComicStrip comic={comic} zoomable />
      <ComicActions comic={comic} />
      <p className="muted small center">
        Made with <Link to="/">Panels</Link> — a drawing game for friends.
      </p>
    </Screen>
  );
}
